import React, { FC } from 'react';
import { IconProps } from './index';

/**
 * @deprecated use zzm-base
 * @param color
 * @param size
 * @constructor
 */
export const Product: FC<IconProps> = ({ color = '#FFFFFF', size = 20 }) => {
  return <svg width={size} height={size} viewBox="0 0 20 20" fill={color} xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M4.64819 5.69009L9.92467 4.02273C9.97369 4.00724 10.0263 4.00724 10.0753 4.02273L15.3518 5.69009C15.5736 5.76017 15.5879 6.06856 15.3736 6.15886L10.0971 8.38201C10.035 8.40816 9.965 8.40816 9.90293 8.38201L4.62644 6.15886C4.41212 6.06856 4.42642 5.76017 4.64819 5.69009ZM9.34328 9.46587L4.34328 7.45497C4.179 7.3889 4 7.50985 4 7.68691V13.0659C4 13.1581 4.05067 13.2427 4.13185 13.2863L9.13185 15.9675C9.2984 16.0568 9.5 15.9361 9.5 15.7471V9.69782C9.5 9.59576 9.43797 9.50395 9.34328 9.46587ZM15.6567 7.45497L10.6567 9.46587C10.562 9.50395 10.5 9.59576 10.5 9.69782V15.7471C10.5 15.9361 10.7016 16.0568 10.8681 15.9675L15.8681 13.2863C15.9493 13.2427 16 13.1581 16 13.0659V7.68691C16 7.50985 15.821 7.3889 15.6567 7.45497Z"/>
  </svg>;
};
